module.exports = __webpack_public_path__ + "static/media/wizwormlogowhite.70763809.png";